import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { getTranslation } from 'utils/compositeTranslationHandler';
import TPTypography from 'components/TP-UI/TPTypography';
import TPDescriptionList from 'components/TP-UI/TPDescriptionList';
import TPLoader from 'components/TP-UI/TPLoader';
import TPCard from 'components/TP-UI/TPCard';
import TPCardContent from 'components/TP-UI/TPCard/components/TPCardContent';
import TPCardTitle from 'components/TP-UI/TPCard/components/TPCardTitle';
import TPCardDescription from 'components/TP-UI/TPCard/components/TPCardDescription';
import TPGrid from 'components/TP-UI/TPGrid';

const Results = ({ descriptionItems, results, loading }) => {
  const { t } = useTranslation('tradingCalculators');

  return (
    <TPCard stretch>
      <TPCardContent>
        <TPCardTitle>{t('resultsTitle')}</TPCardTitle>
        <TPCardDescription>{t('resultsDescription')}</TPCardDescription>
        {loading ? (
          <TPLoader />
        ) : (
          <TPGrid container direction="column" spacing={2}>
            {results.map((resultItem, index) => (
              <TPGrid
                item
                container
                direction="column"
                spacing={1}
                key={`results-fragment-${index}`}>
                {resultItem.title ? (
                  <TPGrid item>
                    <TPTypography variant="h6" key={`results-title-${index}`}>
                      {getTranslation(t, resultItem.title)}
                    </TPTypography>
                  </TPGrid>
                ) : null}
                <TPGrid item>
                  <TPDescriptionList
                    key={`results-description-${index}`}
                    value={resultItem}
                    descriptionProps={descriptionItems[index]}
                  />
                </TPGrid>
              </TPGrid>
            ))}
          </TPGrid>
        )}
      </TPCardContent>
    </TPCard>
  );
};

Results.propTypes = {
  loading: PropTypes.bool,
  descriptionItems: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  results: PropTypes.arrayOf(PropTypes.object),
};

export default Results;
